import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';

import ourprocesssection1bg from '../../assests/ourprocesssection1bg.png';
import homeicon from '../../assests/karaicon.svg';

import processicon1 from '../../assests/processicon1.svg';
import processicon2 from '../../assests/processicon2.svg';
import processicon3 from '../../assests/processicon3.svg';
import processicon4 from '../../assests/processicon4.svg';
import processicon5 from '../../assests/processicon5.svg';
import processicon6 from '../../assests/processicon6.svg';
import Footer from '../Footer';

const OurProcess = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeStep, setActiveStep] = useState(1); // Track which icon is currently active
  const [isConceptOpen, setIsConceptOpen] = useState(false);

const toggleConceptMenu = () => {
  setIsConceptOpen(!isConceptOpen);
};

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Auto-rotate through icons
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prevStep) => {
        // Cycle from 1 to 6, then back to 1
        return prevStep >= 6 ? 1 : prevStep + 1;
      });
    }, 2500); // Change icon every 2.5 seconds

    return () => clearInterval(interval);
  }, []);

  // Throttle function to limit scroll event frequency
  const throttle = (func, delay) => {
    let timeoutId;
    let lastExecTime = 0;
    
    return (...args) => {
      const currentTime = Date.now();
      
      if (currentTime - lastExecTime < delay) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          lastExecTime = currentTime;
          func(...args);
        }, delay);
      } else {
        lastExecTime = currentTime;
        func(...args);
      }
    };
  };

  // Handle scroll behavior - optimized with throttle
  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;
    const section1Height = window.innerHeight * 0.8;

    requestAnimationFrame(() => {
      if (currentScrollY > section1Height) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    });
  }, []);

  useEffect(() => {
    const throttledScroll = throttle(handleScroll, 100);
    window.addEventListener('scroll', throttledScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', throttledScroll);
    };
  }, [handleScroll]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const steps = [
    {
      id: 1,
      icon: processicon1,
      title: "INSIGHT & DISCOVERY",
      description: "We listen deeply—to your space, lifestyle, and aspirations.",
    },
    {
      id: 2,
      icon: processicon2,
      title: "CONCEPT & DESIGN",
      description: "From hand sketches to functional prototypes—your story takes shape.",
    },
    {
      id: 3,
      icon: processicon3,
      title: "TRACEABLE SOURCING",
      description: "Materials with a backstory—ethically sourced and fully traceable.",
    },
    {
      id: 4,
      icon: processicon4,
      title: "CRAFTSMANSHIP & MANUFACTURING",
      description: "Where hand meets heart—crafted by master artisans, down to the last detail.",
    },
    {
      id: 5,
      icon: processicon5,
      title: "CERTIFICATION",
      description: "Each piece is documented for provenance, exclusivity, and quality.",
    },
    {
      id: 6,
      icon: processicon6,
      title: "CURATION & DELIVERY",
      description: "Delivered in eco-luxe packaging, ready to become part of your story.",
    },
  ];

  return (
    <>
      {/* Navbar - Always Visible */}
      <nav className={`our-process-navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="our-process-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="our-process-logo-icon" />
          </Link>
        </div>
        <div className="our-process-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="our-process-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* Navigation Menu Overlay */}
      {isMenuOpen && (
        <div className="our-process-nav-overlay">
          <div className="our-process-nav-close" onClick={toggleMenu}>
            <IoClose className="our-process-close-icon" />
          </div>
          <nav className="our-process-navigation">
            <ul className="our-process-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li className="active"><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              {/* <li><Link to="/hospitality" onClick={toggleMenu}>Hospitality & Commercial Solutions</Link></li>
              <li><Link to="/journal" onClick={toggleMenu}>Journal / Blog</Link></li> */}
               {/* <li className="nav-item-with-submenu">
                <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                  Concept <span className="dropdown-arrow">▼</span>
                </span>
                {isConceptOpen && (
                  <ul className="concept-submenu">
                    <li><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                    <li><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                  </ul>
                )}
              </li> */}
              <li><Link to="/concept" onClick={toggleMenu}>concept</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 1: Process Timeline */}
      <section className="our-process-section-1">
        {/* Background Image */}
        <div className="our-process-section-1-background">
          <img 
            src={ourprocesssection1bg} 
            alt="Process Background" 
            className="our-process-section-1-bg-image"
            loading="eager"
          />
        </div>

        {/* Overlay */}
        <div className="our-process-section-1-overlay"></div>

        <div className="our-process-section-1-content">
          <div className="our-process-section-1-header">
            <p className="our-process-section-1-subtitle">OUR PROCESS</p>
            <h1 className="our-process-section-1-title">
              EVERY PIECE WE CREATE IS PART OF
              <br />
               A THOUGHTFUL JOURNEY— DESIGNED
              <br />
              WITH INTENTION, CRAFTED WITH
              <br />
               CARE.
            </h1>
          </div>

          <div className="our-process-section-1-timeline-wrapper">
            {/* Top Row */}
            <div className="our-process-section-1-row">
              {steps.slice(0, 3).map((step, index) => (
                <div key={step.id} className={`our-process-section-1-step-container ${activeStep === step.id ? 'active-auto' : ''}`}>
                  <div className="our-process-section-1-line-wrapper">
                    <div className="our-process-section-1-top-corner"></div>
                    <div className="our-process-section-1-vertical-line"></div>

                    <div className="our-process-section-1-icon-wrapper">
                      <div className="our-process-section-1-number-badge">{step.id}</div>
                      <div className="our-process-section-1-icon-box">
                        <img 
                          src={step.icon} 
                          alt={`Process ${step.id}`} 
                          className="our-process-section-1-icon-image"
                          loading="lazy"
                        />
                      </div>
                    </div>

                    <div className="our-process-section-1-vertical-line-bottom"></div>
                  </div>

                  <div className="our-process-section-1-text-content-wrapper">
                    <div className="our-process-section-1-text-content">
                      <h3 className="our-process-section-1-step-title">{step.title}</h3>
                      <p className="our-process-section-1-step-description">{step.description}</p>
                    </div>
                  </div>

                  {index < 2 && <div className="our-process-section-1-horizontal-connector"></div>}
                </div>
              ))}
            </div>

            {/* Bottom Row */}
            <div className="our-process-section-1-row">
              {steps.slice(3, 6).map((step, index) => (
                <div key={step.id} className={`our-process-section-1-step-container ${activeStep === step.id ? 'active-auto' : ''}`}>
                  <div className="our-process-section-1-line-wrapper">
                    <div className="our-process-section-1-vertical-line"></div>

                    <div className="our-process-section-1-icon-wrapper">
                      <div className="our-process-section-1-number-badge">{step.id}</div>
                      <div className="our-process-section-1-icon-box">
                        <img 
                          src={step.icon} 
                          alt={`Process ${step.id}`} 
                          className="our-process-section-1-icon-image"
                          loading="lazy"
                        />
                      </div>
                    </div>

                    <div className="our-process-section-1-vertical-line-bottom"></div>
                    <div className="our-process-section-1-bottom-corner"></div>
                  </div>

                  <div className="our-process-section-1-text-content-wrapper">
                    <div className="our-process-section-1-text-content">
                      <h3 className="our-process-section-1-step-title">{step.title}</h3>
                      <p className="our-process-section-1-step-description">{step.description}</p>
                    </div>
                  </div>

                  {index < 2 && <div className="our-process-section-1-horizontal-connector"></div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2: Let's Craft Something */}
      <section className='our-process-section-2'> 
        <h1 className='our-process-section-2-heading-text'>Experience the Journey</h1>
        <p className='our-process-section-2-para-text'>From the first sketch to the final piece in your home, we make the process meaningful, transparent, and timeless.</p>
        <Link to="/contact">
          <button className='our-process-section-2-contact-button'>Experience the Journey</button>
        </Link>
      </section>

      <Footer/>
    </>
  );
};

export default OurProcess;